<template xmlns="http://www.w3.org/1999/html">
    <div class="login-full-a" id="category">
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="container-fluid xyz">
                <div class="page-name">
                    Draggable HR List
                    <button type="submit" v-on:click.prevent="backToUserList()" class="btn btn-primary waves-effect pull-right">Back</button>
                </div>
                <!--page content-->
                <div class="admin-page-content">
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in imageList">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                <span class="btn edit-btn-vvg waves-effect">
                                        <img :src="text.profile_image" :key="index" class="img-rounded"/>
                                    <p class="well text-danger"><strong>{{text.first_name}} {{text.last_name}}</strong></p>
                                </span>
                            </div>
                        </template>
                    </draggable>
                </div>
                <!--page content-->
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import Footer from "@/components/partials/Footer";
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-footer': Footer,
        },
        data() {
            return {
                sliderType: '',
                imageList: [],
                imagePosition: [],
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.sliderType = this.$route.params.type;
            self.getImages();
        },
        watch: {
            '$route'() {
                self.sliderType = this.$route.params.type;
                self.getImages();
            }
        },
        methods: {
            backToUserList() {
                self.$router.push('/backend/listusers/');
            },
            getImages() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        // 'type': self.sliderType,
                    }
                };

                HTTP.get("gethrimages", config)
                    .then(function (response) {
                        self.imageList = response.data.content;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                    'type': self.sliderType,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                };
                HTTP.post("changepositionhr", fields, config)
                    .then(function (response) {
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        },
    }
</script>
